import React from 'react';
import '../assets/header.css'
// import AppCache from '../modules/AppCache';
import * as _ from 'lodash';
import TagManager from 'react-gtm-module';
import LazyLoad from './LazyLoad';

const tagManagerArgs = {
	gtmId: 'GTM-P4SN8ZN',
}
TagManager.initialize(tagManagerArgs)

export default class Header extends React.Component {

	constructor(props) {
		super(props);
		this.addActiveClass = this.addActiveClass.bind(this);
		this.toggleClick = this.toggleClick.bind(this);
		this.handleMouseOver = this.handleMouseOver.bind(this);
		this.handleMouseOverSupport = this.handleMouseOverSupport.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
		this.handleMouseOutSupport = this.handleMouseOutSupport.bind(this);
		this.toggleMobileHeaderMenu = this.toggleMobileHeaderMenu.bind(this);
		this.closeMobileMenus = this.closeMobileMenus.bind(this);
		this.state = {
			active: true,
			dropdownActive: true,
			dropdownHoverActive: '',
			dropdownHoverActiveSupport: '',
			mobileHeaderMenus: false,
			windowHeight: undefined,
    		windowWidth: undefined,
		};
	}

	handleResize = () => this.setState({
		windowHeight: window.innerHeight,
		windowWidth: window.innerWidth
	});

	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize)
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize)
	}

	addActiveClass() {
		const currentState = this.state.active;
		this.setState({ active: !currentState });

		this.setState({
			active: !this.state.active,
		})
	}

	toggleClick() {
		const currentState = this.state.dropdownActive;
		this.setState({ dropdownActive: !currentState });

		this.setState({
			dropdownActive: !this.state.dropdownActive
		})
	}

	// toggleClickSupport () {
	//     const currentState = this.state.dropdownActiveSupport;
	//     this.setState({ dropdownActiveSupport: !currentState });

	//     this.setState({
	//         dropdownActiveSupport: !this.state.dropdownActiveSupport
	//       })
	// }

	isMobile() {	//sniff a mobile browser
		if (navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPod/i)
		) {
			return true;
		}
	}

	handleMouseOver() {
		this.setState({
			dropdownHoverActive: true
		})
	}

	handleMouseOverSupport() {
		this.setState({
			dropdownHoverActiveSupport: true
		})
	}

	handleMouseOut() {
		this.setState({
			dropdownHoverActive: false
		})
	}

	handleMouseOutSupport() {
		this.setState({
			dropdownHoverActiveSupport: false
		})
	}

	toggleMobileHeaderMenu() {
		this.setState({
			mobileHeaderMenus: true
		})
	}

	closeMobileMenus() {
		this.setState({ mobileHeaderMenus: false })
	}

	render() {
		let writerNumber, writerType
		const query = new URLSearchParams(window.location.search);
		if (query.get('writer_type')) {
			writerNumber = query.get('writer_type');
			writerType = query.get('writer_type') == "1" ? "creative_writers" : "songwriters";
		} else {
			// requestUrl = request.getAttribute("javax.servlet.forward.request_uri").toString();
			// writerType = requestUrl.contains("CW")? "creative_writers" : "songwriters";
			// writerNumber = requestUrl.contains("CW")? "1" : "2";
		}
		let websiteURL = 'http://masterwriter.com/',
			//contextPath = '/store/',
			//blogURL = websiteURL + "blog/",
			//homeLink = websiteURL + writerType,
			//buyLink = websiteURL + writerType + "/purchase",
			//upgradeLink = "https://www3.masterwriter.com/store/MW2ToMW3NewUpgrade.do?writer_type=" + writerNumber,
			//redeemLink = "https://www3.masterwriter.com/store/NewRetailer.do?writer_type=" + writerNumber,
			// String freeTrialLink = "https://app.masterwriter.com/register/freetrial-new?account_type=1&writer_type=" + writerNumber;
			//blogLink = "https://masterwriter.com/" + writerType + "/blog/",
			testimonialsLink = websiteURL + writerType + "/testimonials"
			//notableUsersLink = websiteURL + writerType + "/notable_users",
			//loginLink = "https://app.masterwriter.com/login/new?writer_type=" + writerNumber
		return (
			<>
				<div data-elementor-type="header" data-elementor-id="3733"
					className="elementor elementor-3733 elementor-location-header header-start-sticky" data-elementor-post-type="elementor_library" style={{ position: this.state.windowWidth <= 768 ? 'relative' : 'sticky', zIndex: '999', top: 0 }}>
					<section
						className="elementor-section elementor-top-section elementor-element elementor-element-cfe6e8f elementor-section-content-middle elementor-hidden-mobile elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
						data-id="cfe6e8f" data-element_type="section" id="header_SW_desktop"
						data-settings="{&quot;sticky&quot;:&quot;top&quot;,&quot;background_background&quot;:&quot;classic&quot;,&quot;sticky_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;,&quot;mobile&quot;],&quot;sticky_offset&quot;:0,&quot;sticky_effects_offset&quot;:0}">
						<div className="elementor-container elementor-column-gap-default">
							<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4bb996f"
								data-id="4bb996f" data-element_type="column">
								<div className="elementor-widget-wrap elementor-element-populated">
									<section
										className="elementor-section elementor-inner-section elementor-element elementor-element-ea2203f elementor-section-content-middle elementor-section-full_width elementor-section-height-default elementor-section-height-default"
										data-id="ea2203f" data-element_type="section"
										data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ecc5a1d"
												data-id="ecc5a1d" data-element_type="column"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-2cae465 elementor-widget elementor-widget-image"
														data-id="2cae465" data-element_type="widget"
														data-widget_type="image.default">
														<div className="elementor-widget-container">
															<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters' : 'https://masterwriter.com/creative_writers'}> <LazyLoad width="800" height="127"><img 
																src="/store/images/2022-05-WM_logoWhole_wR2@2x-1024x163.png"
																className="attachment-large size-large wp-image-5285" alt=""
																loading="lazy"
																srcSet="/store/images/2022-05-WM_logoWhole_wR2@2x-1024x163.png 1024w, /store/images/2022-05-WM_logoWhole_wR2@2x-300x48.png 300w, /store/images/2022-05-WM_logoWhole_wR2@2x-768x122.png 768w, /store/images/2022-05-WM_logoWhole_wR2@2x.png 1462w"
																sizes="(max-width: 800px) 100vw, 800px" /></LazyLoad> </a>
														</div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-dbbf964"
												data-id="dbbf964" data-element_type="column"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-03db1ef elementor-nav-menu__align-right elementor-nav-menu--dropdown-none elementor-widget__width-auto elementor-widget elementor-widget-nav-menu"
														data-id="03db1ef" data-element_type="widget"
														data-settings="{&quot;submenu_icon&quot;:{&quot;value&quot;:&quot;&lt;i className=\&quot;\&quot;&gt;&lt;\/i&gt;&quot;,&quot;library&quot;:&quot;&quot;},&quot;layout&quot;:&quot;horizontal&quot;}"
														data-widget_type="nav-menu.default">
														<div className="elementor-widget-container">

															<nav
																className="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal e--pointer-background e--animation-none">
																<ul id="menu-1-03db1ef" className="elementor-nav-menu" >
																	{writerNumber == "2" ?
																		<li
																			className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18975" onMouseEnter={this.handleMouseOver} onMouseLeave={this.handleMouseOut}>
																			<a
																				className={`${this.state.dropdownHoverActive ? "elementor-item elementor-item-anchor highlighted" : "elementor-item elementor-item-anchor"}`}>Testimonials</a>
																			<ul className='sub-menu elementor-nav-menu--dropdown' style={{ display: this.state.dropdownHoverActive ? 'block' : 'none', cursor: 'pointer' }}>
																				<li
																					className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18976">
																					<a href="https://masterwriter.com/songwriters/testimonials/"
																						className="elementor-sub-item">Testimonials</a></li>
																				<li
																					className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18977">
																					<a href="https://masterwriter.com/songwriters/notable_users/"
																						className="elementor-sub-item">Notable Users</a>
																				</li>
																			</ul>
																		</li>
																		: <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18975">
																			<a href="https://masterwriter.com/creative_writers/testimonials/"
																				className="elementor-item elementor-item-anchor">Testimonials</a></li>
																	}
																	<li
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18978">
																		<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/blog/' : 'https://masterwriter.com/creative_writers/blog/'}
																			className="elementor-item">Blog</a></li>
																	<li
																		className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18979" onMouseEnter={this.handleMouseOverSupport} onMouseLeave={this.handleMouseOutSupport}>
																		<a href=""
																			className={`${this.state.dropdownHoverActiveSupport ? "elementor-item elementor-item-anchor highlighted" : "elementor-item elementor-item-anchor"}`} >Support</a>
																		<ul className="sub-menu elementor-nav-menu--dropdown" style={{ display: this.state.dropdownHoverActiveSupport ? 'block' : 'none' }} >
																			<li
																				className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18980">
																				<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/faqs/' : 'https://masterwriter.com/creative_writers/faqs/'} className="elementor-sub-item">
																					FAQs</a></li>
																			<li
																				className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18981">
																				<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/contact/' : 'https://masterwriter.com/creative_writers/contact/'}
																					className="elementor-sub-item">Contact</a></li>
																		</ul>
																	</li>
																</ul>
															</nav>
															<nav className="elementor-nav-menu--dropdown elementor-nav-menu__container"
																aria-hidden="true">
																<ul id="menu-2-03db1ef" className="elementor-nav-menu">
																	<li
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19597">
																		<a href={testimonialsLink}
																			className="elementor-item" tabIndex="-1">Testimonials</a>
																	</li>
																	{writerNumber == "2" ?
																		<li
																			className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18975">
																			<a href="https://masterwriter.com/songwriters/testimonials/" className="elementor-item elementor-item-anchor"
																				tabIndex="-1">Testimonials</a>
																			<ul className="sub-menu elementor-nav-menu--dropdown">
																				<li
																					className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18976">
																					<a href="https://masterwriter.com/songwriters/testimonials/"
																						className="elementor-sub-item"
																						tabIndex="-1">Testimonials</a></li>
																				<li
																					className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18977">
																					<a href="https://masterwriter.com/songwriters/notable_users/"
																						className="elementor-sub-item" tabIndex="-1">Notable
																						Users</a></li>
																			</ul>
																		</li>
																		: <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18975">
																			<a href="https://masterwriter.com/creative_writers/testimonials/"
																				className="elementor-item elementor-item-anchor">Testimonials</a></li>
																	}
																	<li
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18978">
																		<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/blog/' : 'https://masterwriter.com/creative_writers/blog/'}
																			className="elementor-item" tabIndex="-1">Blog</a></li>
																	<li
																		className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18979">
																		<a href="#" className="elementor-item elementor-item-anchor"
																			tabIndex="-1">Support</a>
																		<ul className="sub-menu elementor-nav-menu--dropdown">
																			<li
																				className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18980">
																				<a href="https://masterwriter.com/songwriters/faqs/"
																					className="elementor-sub-item"
																					tabIndex="-1">FAQs</a></li>
																			<li
																				className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18981">
																				<a href="https://masterwriter.com/songwriters/contact/"
																					className="elementor-sub-item"
																					tabIndex="-1">Contact</a></li>
																		</ul>
																	</li>
																</ul>
															</nav>
														</div>
													</div>
													<div className="elementor-element elementor-element-fbf4d74 elementor-widget__width-auto elementor-widget-tablet__width-auto elementor-widget elementor-widget-text-editor"
														data-id="fbf4d74" data-element_type="widget"
														data-widget_type="text-editor.default">
														<div className="elementor-widget-container">
															<a className="mastheadBTN" href={writerNumber == "2" ? 'https://app.masterwriter.com/login/new?writer_type=2' : 'https://app.masterwriter.com/login/new?writer_type=1'}>Login</a>
														</div>
													</div>
													<div className="elementor-element elementor-element-dfa4242 elementor-widget__width-auto elementor-widget-tablet__width-auto elementor-widget elementor-widget-button"
														data-id="dfa4242" data-element_type="widget"
														data-widget_type="button.default">
														<div className="elementor-widget-container">
															<div className="elementor-button-wrapper"> <a
																className="elementor-button elementor-button-link elementor-size-sm"
																href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/purchase/' : 'https://masterwriter.com/creative_writers/purchase/'}> <span
																	className="elementor-button-content-wrapper"> <span
																		className="elementor-button-text">Buy Now</span> </span>
															</a> </div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</section>
					<section
						className="elementor-section elementor-top-section elementor-element elementor-element-03cf0c5 elementor-hidden-desktop elementor-hidden-tablet elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-section-items-middle"
						data-id="03cf0c5" data-element_type="section" id="header_SW_mobile">
						<div className="elementor-container elementor-column-gap-default">
							<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1341518"
								data-id="1341518" data-element_type="column">
								<div className="elementor-widget-wrap elementor-element-populated">
									<section
										className="elementor-section elementor-inner-section elementor-element elementor-element-4f916eb elementor-section-content-middle elementor-section-full_width elementor-section-height-default elementor-section-height-default"
										data-id="4f916eb" data-element_type="section"
										data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-111a309"
												data-id="111a309" data-element_type="column"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-1630749 elementor-widget elementor-widget-image"
														data-id="1630749" data-element_type="widget"
														data-widget_type="image.default">
														<div className="elementor-widget-container"> <a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters' : 'https://masterwriter.com/creative_writers'}> <LazyLoad width="145" height="134"> <img
															src="./images/2022-05-mw-icon-white_1.png"
															className="attachment-large size-large wp-image-19217" alt=""
															loading="lazy" /></LazyLoad> </a> </div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-db170bb"
												data-id="db170bb" data-element_type="column">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-497b5c1 elementor-widget-mobile__width-auto login-link elementor-widget elementor-widget-html"
														data-id="497b5c1" data-element_type="widget"
														data-widget_type="html.default">
														<div className="elementor-widget-container"> <a href={writerNumber == "2" ? 'https://app.masterwriter.com/login/new?writer_type=2' : 'https://app.masterwriter.com/login/new?writer_type=1'}
															className="mobile-nav-text-link">Login</a> </div>
													</div>
													<div className="elementor-element elementor-element-f555a1f elementor-widget__width-auto elementor-align-center elementor-widget elementor-widget-button"
														data-id="f555a1f" data-element_type="widget"
														data-widget_type="button.default">
														<div className="elementor-widget-container">
															<div className="elementor-button-wrapper"> <a
																className="elementor-button elementor-button-link elementor-size-sm"
																href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/purchase/' : 'https://masterwriter.com/creative_writers/purchase/'}> <span
																	className="elementor-button-content-wrapper"> <span
																		className="elementor-button-text">Buy</span> </span> </a>
															</div>
														</div>
													</div>

													<div className="elementor-element elementor-element-ff600ad elementor-widget-mobile__width-auto hamburger-menu elementor-view-default elementor-widget elementor-widget-icon"
														data-id="ff600ad" data-element_type="widget"
														data-widget_type="icon.default" onClick={this.toggleMobileHeaderMenu}>
														<div className="elementor-widget-container">
															<div className="elementor-icon-wrapper"> <a className="elementor-icon"
															>
																<i className="fas fa-bars"></i>
															</a>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</section>
					<div className="dialog-widget dialog-lightbox-widget dialog-type-buttons dialog-type-lightbox elementor-popup-modal"
						id="elementor-popup-modal-19108" aria-modal="true" role="document" tabIndex="0" style={{ display: this.state.mobileHeaderMenus ? 'block' : 'none', cursor: 'pointer' }}>
						<div className="dialog-widget-content dialog-lightbox-widget-content animated" style={{ width: '100%' }}>
							<div className="dialog-header dialog-lightbox-header"></div>
							<div data-elementor-type="popup" data-elementor-id="19108"
								className="elementor elementor-19108 elementor-location-popup"
								data-elementor-settings="{&quot;entrance_animation&quot;:&quot;fadeInDown&quot;,&quot;exit_animation&quot;:&quot;fadeInDown&quot;,&quot;entrance_animation_duration&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0.6,&quot;sizes&quot;:[]},&quot;a11y_navigation&quot;:&quot;yes&quot;,&quot;timing&quot;:[]}"
								data-elementor-post-type="elementor_library" style={{ display: 'block' }}>
								<div className="elementor-element elementor-element-92381d3 e-flex e-con-boxed e-con" data-id="92381d3"
									data-element_type="container"
									data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
									<div className="e-con-inner">
										<div className="elementor-element elementor-element-a7dc136 elementor-widget elementor-widget-bdt-accordion"
											data-id="a7dc136" data-element_type="widget" data-widget_type="bdt-accordion.default">
											{writerNumber == "2" ?
												<div className="elementor-widget-container">
													<div className="bdt-ep-accordion-container">
														<div id="bdt-ep-accordion-a7dc136" className="bdt-ep-accordion bdt-accordion"
															data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:false,&quot;transition&quot;:&quot;ease-in-out&quot;}"
															data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-a7dc136&quot;,&quot;activeHash&quot;:&quot;no&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
															<div className="bdt-ep-accordion-item">
																<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle bdt-flex-between"
																	id="bdt-ep-accordion-testimonials" data-accordion-index="0"
																	data-title="testimonials" role="heading"> <span
																		className="bdt-ep-accordion-icon bdt-flex-align-right" aria-hidden="true"> <span
																			className="bdt-ep-accordion-icon-closed">

																			<svg viewBox="0 0 448 512">
																				<path
																					d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
																					fill="white" stroke="white"
																				/>
																			</svg></span> <span className="bdt-ep-accordion-icon-opened">
																			<svg viewBox="0 0 448 512">
																				<path
																					d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
																					fill="white" stroke="white"
																				/>
																			</svg>
																		</span> </span> <span
																			className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Testimonials </span>
																</div>
																<div className="bdt-ep-accordion-content bdt-accordion-content">
																	<div className="mobile-submenus"> <a
																		href="https://masterwriter.com/songwriters/testimonials/">Testimonials</a><br className="" /><a
																			href="https://masterwriter.com/songwriters/notable_users/">Notable Users</a> </div>
																</div>
															</div>
														</div>
													</div>
												</div>
												: <div data-ep-wrapper-link="{&quot;url&quot;:&quot;\/songwriting\/blog\/&quot;,&quot;is_external&quot;:&quot;&quot;,&quot;nofollow&quot;:&quot;&quot;,&quot;custom_attributes&quot;:&quot;&quot;}"
													style={{ cursor: 'pointer' }}
													className="bdt-element-link elementor-element elementor-element-3fd967d elementor-widget elementor-widget-bdt-accordion"
													data-id="3fd967d" data-element_type="widget" data-widget_type="bdt-accordion.default">
													<div className="elementor-widget-container">
														<div className="bdt-ep-accordion-container">
															<div id="bdt-ep-accordion-3fd967d" className="bdt-ep-accordion bdt-accordion"
																data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:true,&quot;transition&quot;:&quot;ease-in-out&quot;}"
																data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-3fd967d&quot;,&quot;activeHash&quot;:&quot;&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
																<div className="bdt-ep-accordion-item">
																	<a href="https://masterwriter.com/creative_writers/testimonials/">
																		<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle"
																			id="bdt-ep-accordion-blog" data-accordion-index="0" data-title="blog"
																			role="heading">
																			<span className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Testimonials
																			</span></div></a>

																	<div className="bdt-ep-accordion-content bdt-accordion-content">
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											}
										</div>
										<div data-ep-wrapper-link="{&quot;url&quot;:&quot;\/songwriting\/blog\/&quot;,&quot;is_external&quot;:&quot;&quot;,&quot;nofollow&quot;:&quot;&quot;,&quot;custom_attributes&quot;:&quot;&quot;}"
											style={{ cursor: 'pointer' }}
											className="bdt-element-link elementor-element elementor-element-3fd967d elementor-widget elementor-widget-bdt-accordion"
											data-id="3fd967d" data-element_type="widget" data-widget_type="bdt-accordion.default">
											<div className="elementor-widget-container">
												<div className="bdt-ep-accordion-container">
													<div id="bdt-ep-accordion-3fd967d" className="bdt-ep-accordion bdt-accordion"
														data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:true,&quot;transition&quot;:&quot;ease-in-out&quot;}"
														data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-3fd967d&quot;,&quot;activeHash&quot;:&quot;&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
														<div className="bdt-ep-accordion-item">
															<a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/blog/' : 'https://masterwriter.com/creative_writers/blog/'}>
																<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle"
																	id="bdt-ep-accordion-blog" data-accordion-index="0" data-title="blog"
																	role="heading">
																	<span className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Blog
																	</span></div></a>

															<div className="bdt-ep-accordion-content bdt-accordion-content">
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-4ae0afc elementor-widget elementor-widget-bdt-accordion"
											data-id="4ae0afc" data-element_type="widget" data-widget_type="bdt-accordion.default">
											<div className="elementor-widget-container">
												<div className="bdt-ep-accordion-container">
													<div id="bdt-ep-accordion-4ae0afc" className="bdt-ep-accordion bdt-accordion"
														data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:false,&quot;transition&quot;:&quot;ease-in-out&quot;}"
														data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-4ae0afc&quot;,&quot;activeHash&quot;:&quot;no&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
														<div className="bdt-ep-accordion-item">
															<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle bdt-flex-between"
																id="bdt-ep-accordion-support" data-accordion-index="0" data-title="support"
																role="heading"> <span className="bdt-ep-accordion-icon bdt-flex-align-right"
																	aria-hidden="true"> <span className="bdt-ep-accordion-icon-closed"> <svg viewBox="0 0 448 512">
																		<path
																			d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
																			fill="white" stroke="white"
																		/>
																	</svg> 
																	</span> <span className="bdt-ep-accordion-icon-opened"> <svg viewBox="0 0 448 512">
																		<path
																			d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
																			fill="white" stroke="white"
																		/>
																	</svg></span> </span> <span
																		className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Support </span> </div>
															<div className="bdt-ep-accordion-content bdt-accordion-content">
																<div className="mobile-submenus"> <a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/faqs/' : 'https://masterwriter.com/creative_writers/faqs/'}>FAQs</a> <br
																	className="" /> <a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters/contact/' : 'https://masterwriter.com/creative_writers/contact/'}>Contact</a> </div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="dialog-buttons-wrapper dialog-lightbox-buttons-wrapper" ></div><a role="button" tabIndex="0"
								aria-label="Close" className="dialog-close-button dialog-lightbox-close-button" onClick={this.closeMobileMenus}><svg viewBox="0 0 448 512">


									<path d="m437.5,386.6l-130.6,-130.6l130.6,-130.6c14.1,-14.1 14.1,-36.8 0,-50.9c-14.1,-14.1 -36.8,-14.1 -50.9,0l-130.6,130.6l-130.6,-130.6c-14.1,-14.1 -36.8,-14.1 -50.9,0c-14.1,14.1 -14.1,36.8 0,50.9l130.6,130.6l-130.6,130.6c-14.1,14.1 -14.1,36.8 0,50.9c14.1,14.1 36.8,14.1 50.9,0l130.6,-130.6l130.6,130.6c14.1,14.1 36.8,14.1 50.9,0c14,-14.1 14,-36.9 0,-50.9z"
										fill="white" stroke="white"
									/>
								</svg></a>
						</div>
					</div>
				</div>
			</>
		)
	}

}